<!-- <app-side-navbar></app-side-navbar> -->

<section class="ask-a-doubt">
  <div class="container">
    <div id="recaptcha-container"></div>
    <div class="row">
      <div class="col-lg-8">
        <div class="doubt">
          <div>
            <h4>Ask a Doubt</h4>
            <p>Welcome to the AskIITians Forum! Your Gateway to Boundless Learning and Collaborative Exploration!</p>
          </div>
        </div>
        <div class="loader-overlay" *ngIf="isLoading">
          <div class="spinner">
            <div></div>
            <div></div>
          </div>
        </div>
        <form [formGroup]="forumQuestion">
          <div class="menu d-flex row">
            <div class="col-lg-3 col-md-3 col-sm-5 col-5">
              <select
                formControlName="grade"
                #parentCategory
                [(ngModel)]="gradeID"
                (change)="populateCategory(parentCategory.value)"
                class="form-select select-1"
                aria-label="Default select example"
              >
                <!-- <option value="">12 Grade</option> -->
                <option *ngFor="let p of ParentCategory; let i = index" [value]="p.id">
                  {{ p.name }}
                </option>
                <!-- <option  *ngFor="let p of ParentCategory; let i = index" [value]="p.id">{{p.name}}</option> -->
              </select>
            </div>
            <div class="col-lg-4 col-md-4 col-7 subcategory">
              <select
                #SubCategory
                [(ngModel)]="selectedSubCategory"
                (change)="subCategories(SubCategory.value)"
                class="mb-0 form-select select-2"
                formControlName="category"
                [ngClass]="{ 'is-invalid': isSubmitted && f['category'].errors }"
              >
                <option value="">--Select--</option>
                <option *ngFor="let c of dropdownCategory" [value]="c.id">
                  {{ c.name }}
                </option>
              </select>
              <div
                *ngIf="isSubmitted && f['category'].errors && f['category'].errors['required']"
                class="alert alert-danger mt-1 mb-0 select-2"
              >
                Please select Category
              </div>
            </div>
            <div class="col-lg-4">
              <select
                formControlName="subCategory"
                [(ngModel)]="selectedSubTopicCategory"
                #Category
                (change)="Categories(Category.value)"
                [hidden]="show"
                class="form-select select-2 margin-select-2"
                [ngClass]="{ 'is-invalid': isSubmitted && f['subCategory'].errors }"
              >
                <option value="">--Select--</option>
                <option *ngFor="let s of dropdownsubCategory" [value]="s.id">
                  {{ s.name }}
                </option>
              </select>
              <div
                *ngIf="isSubmitted && f['subCategory'].errors && f['subCategory'].errors['required']"
                class="alert col-lg-5 alert-danger mt-1 select-2 margin-select-2"
              >
                Please select Sub-Category
              </div>
            </div>
          </div>
        </form>
        <div class="row row-2">
          <p class="para-1">Doubt</p>
          <div>
            <app-angular-editor
              (contentUpdated)="fetchHtmlContentFromEditor($event)"
              [isAnsweUploaded]="isAnsweUploaded"
            ></app-angular-editor>
          </div>
          <div *ngIf="!isValidQuestion" class="alert alert-danger mt-1" style="width: 97%; margin: auto">
            Please write your Question Description atleast 50 characters length.
          </div>
          <form [formGroup]="forumQuestiontags">
            <div class="control-section uploadFrmCTA" style="margin-top: 14px">
              <input
                formControlName="imageQuestion"
                type="file"
                name="files"
                accept="image/*"
                src="/src/assets/images/QuestionImages/Capture.PNG"
                (change)="onFileChanged($event)"
                style="width: -webkit-fill-available"
              />
            </div>
            <div class="chips-seation">
              <!-- <button class="get_answer"  *ngIf="isPaidUser" (click)="onSubmit()" [class.changestyle]="check">GET ANSWER</button> -->
              <app-google-recaptcha *ngIf="GoogleRE_CAPTCHA_IsEnabled" (tokenId)="isResolved($event)"></app-google-recaptcha>
              <button class="get_answer" (click)="onSubmit()" [class.changestyle]="check">GET ANSWER</button>
              <!-- <button class="get_answer changestyle">GET ANSWER</button> -->
            </div>
            <!-- <div style="margin-top: 10px;">
              <p class="contentborder">
                Unleash your boundless curiosity here. Ignite your quest for knowledge by asking questions to subject experts, tutors,
                instructors, and your fellow peers, fostering an enriching learning experience. Join the conversation, seek answers,
                and embark on a thrilling journey of discovery. Together, let's learn, discuss, and grow!
              </p>
            </div> -->
          </form>
        </div>
        <div style="margin-top: 10px">
          <p class="contentborder">
            Unleash your boundless curiosity here. Ignite your quest for knowledge by asking questions to subject experts, tutors,
            instructors, and your fellow peers, fostering an enriching learning experience. Join the conversation, seek answers, and
            embark on a thrilling journey of discovery. Together, let's learn, discuss, and grow!
          </p>
        </div>

        <div class="row row-3" *ngIf="getCatList && getCatList?.length > 0">
          <h1>
            <h2 class="other-related-tag">Other Related Questions on {{ this.categoryName }}</h2>
          </h1>
          <!-- <p>Lorem Ipsum is simply dummy text</p> -->
          <hr />
          <!-- <p></p> -->
          <div class="relate-question d-flex gap-2" *ngFor="let items of getCatList">
            <div class="img">
              <img
                loading="lazy"
                src="/assets/images/resource/resourse-doubt/question-mark.png"
                alt="question-mark"
                width="20px"
                height="20px"
              />
            </div>
            <div class="content" style="word-break: break-all; width: inherit">
              <h6>
                <a
                  [routerLink]="
                    items.questionLink.split('/').length === 1
                      ? ['/forums/' + items.questionLink.split('/')[0]]
                      : items.questionLink.split('/').length === 2
                      ? ['/forums/' + categoryToRedirect + '/' + items.questionLink.split('/')[1]]
                      : items.questionLink.split('/').length === 4
                      ? [
                          '/forums/' +
                            items.questionLink.split('/')[0] +
                            '/' +
                            items.questionLink.split('/')[1] +
                            '/' +
                            items.questionLink.split('/')[2] +
                            '/' +
                            items.questionLink.split('/')[3]
                        ]
                      : null
                  "
                  [ngClass]="{ limitTextHeight: isReadMore }"
                >
                  <div [innerHTML]="items.questionDescription"></div>
                </a>
              </h6>
              <h6>{{ items.grade == 0 ? this.categoryName : " " + " Grade " + items.grade + " > " + this.categoryName }}</h6>
              <div class="button d-flex">
                <button *ngFor="let tag of items.sysTags">
                  {{ tag.attributeData.obj.title }}
                </button>
              </div>

              <div class="answer d-flex justify-content-between">
                <a
                  class="availableAns"
                  *ngIf="items.answerCount > 0; else noAnswerAvailable"
                  [routerLink]="
                    items.questionLink.split('/').length === 1
                      ? ['/forums/' + items.questionLink.split('/')[0]]
                      : items.questionLink.split('/').length === 2
                      ? ['/forums/' + categoryToRedirect + '/' + items.questionLink.split('/')[1]]
                      : items.questionLink.split('/').length === 4
                      ? [
                          '/forums/' +
                            items.questionLink.split('/')[0] +
                            '/' +
                            items.questionLink.split('/')[1] +
                            '/' +
                            items.questionLink.split('/')[2] +
                            '/' +
                            items.questionLink.split('/')[3]
                        ]
                      : null
                  "
                >
                  {{ items.answerCount === 1 ? items.answerCount + " Answer" : items.answerCount + " Answers" }}
                  Available
                </a>
                <ng-template #noAnswerAvailable>
                  <span> 0 Answer Available </span>
                </ng-template>
                <p>
                  Last Activity:
                  {{ getLastActivity(items.postDate) }}
                </p>
              </div>
            </div>
          </div>
          <div>
            <div class="d-flex justify-content-between mb-2 mobMbt">
              <div>
                <button
                  class="pagination_btn"
                  *ngIf="isViewAllPrevious"
                  (click)="getPriviousQuestion()"
                  [class.changestyle]="isCheckPrevious"
                >
                  Previous
                </button>
              </div>
              <div>
                <button class="pagination_btn" *ngIf="isViewAllNext" [class.changestyle]="isCheckNext" (click)="getNextquestion()">
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 text-">
        <div class="row">
          <h5>Inspiration</h5>
          <div class="col-lg-6 col-6" *ngFor="let item of blogs">
            <div class="back-shadow">
              <div class="image w-90">
                <img
                  loading="lazy"
                  src="{{ item._embedded['wp:featuredmedia'][0].source_url }}"
                  alt="blogs"
                  width="169px"
                  height="169px"
                  class="w-100"
                />
              </div>
              <div class="material w-90">
                <p>
                  {{ htmlToSimpleText.getHtmlSimpleText(item.excerpt.rendered) | slice : 0 : 40 }} <span *ngIf="!showMore">...</span>
                </p>

                <div class="d-flex align-items-center gap-lg-2">
                  <a (click)="goToBlogDetailed(item.slug)"> Read More</a>
                  <div>
                    <img
                      loading="lazy"
                      src="/assets/images/resourse-img/right-angle.png"
                      width="8px"
                      height="12px"
                      alt="right-angle"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="button">
          <button class="viewmore" (click)="goToBlog()">View More</button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- NOTE: Mobile View  -->
<!-- <div class="right-1 bottom-fix d-block d-md-none mb-0 position-fixed bottom-0 w-100" style="z-index: 50">
    <div class="img">
      <div>
        <img src="/assets/images/resourse-img/star.png" alt="" class="img-fluid" />
      </div>
      <h5>LIVE ONLINE CLASSES</h5>
    </div>
  
    <div class="button-3 d-flex gap-3">
      <button class="btn-1 w-100" *ngIf="canBuy">Buy Now </button> 
      <button class="btn-1 w-100" *ngIf="!canBuy" (click)="openChildFreeTrial()">Start your free trial</button>
    </div>
  </div> -->
